import React, { useCallback } from 'react';
import { AppButton, Box, Inscription, RoundDoneIcon } from '@common-fe/common-fe';

import { ModalWrapper } from '@/components/wrappers';

interface Props {
  onSetVisible: (value: boolean) => void;
}

const EmailSuccessfullyVerifiedModal: React.FC<Props> = ({ onSetVisible }) => {
  const handleGoToHomeDashboard = useCallback(() => {
    onSetVisible(false);
  }, [onSetVisible]);

  return (
    <ModalWrapper testId="SuccessfulAuthentication" visible onSetVisible={onSetVisible}>
      <Box pad={{ vertical: 'spacing24' }} align="center">
        <RoundDoneIcon size="48px" />

        <Inscription margin={{ top: 'spacing12' }} size="2xl" weight={700}>
          Success
        </Inscription>

        <Inscription margin={{ top: 'spacing12' }}>
          Your email address has been verified!
        </Inscription>
        
        <Box
          margin={{ top: 'spacing24' }}
          direction="row"
          justify="center"
          width="100%"
        >
          <Box width={{ width: '100%', max: '210px' }}>
            <AppButton
              width="100%"
              onClick={handleGoToHomeDashboard}
            >
              Go to Home Dashboard
            </AppButton>
          </Box>
        </Box>
      </Box>     
    </ModalWrapper>
  );
};

export default EmailSuccessfullyVerifiedModal;
